const projectsData = [
  {
  id: "AVVNL",
  title: "AVVNL Feeder Segregation Project" ,
  // titles: "AVVNL 33/11 KV Underground Cabling & Overhead Lines Project",
  titles: "AVVNL Feeder Segregation Project",
  category: "ongoing",
  image: "/projects/project high quality/OP1.jpeg",
  description: "Developing a modern power distribution network across Sikar district, Rajasthan, focused on the segregation of 11 KV mixed load feeders to enhance efficiency and reliability. The project includes the installation of both underground and overhead Aerial Bunched Conductor (ABC) cabling systems, along with the construction of multiple 33/11 KV grid substations to strengthen the power infrastructure and ensure stable electricity supply.",  
  location: "(Rajasthan)",
  date: "--------------",
  cost: "----------------",
  authority: "AVVNL 33/11 KV Underground Cabling & Overhead Lines Project"
  },
  {
  id: "HPSEBL",
  title: "HPSEBL GIS Sub-Stations Construction Project",
  titles: "HPSEBL GIS Sub-Stations Construction Project",
  // titles: "HPSEBL GIS Sub-Stations (E-Houses) Construction & 11 KV Underground Cabling & Overhead Lines Project",
  category: "ongoing",
  image: "/projects/project high quality/OP2.jpg",
  description :"Executing a World Bank–funded project involving the construction of advanced GIS substations (E-houses) at multiple locations across Himachal Pradesh. The project also includes the development of 11 KV underground cabling networks and overhead transmission lines, aimed at strengthening the power distribution infrastructure, improving reliability and ensuring efficient electricity supply in the region.",
  location: "(Himachal Pradesh)",
  date: "--------------",
  cost: "----------------",
  authority: "HPSEBL GIS Sub-Stations (E-Houses) Construction & 11 KV Underground Cabling & Overhead Lines Project"
},
{
  id: "MGVCL",
  title: "MGVCL Underground Cabling Project",
  titles: "MGVCL Underground Cabling Project",
  // titles: "MGVCL 11 KV Underground Cabling & MVCC Conductoring Project under Robust & RDSS scheme.",
  category: "ongoing",
  image: "/projects/project high quality/OP3.jpeg",
  description :"Executing State Government and Central Government–funded projects in Vadodara, Gujarat, focused on strengthening the urban power distribution network. The scope includes the conversion of existing 11 KV overhead lines into underground cabling systems, installation of MVCC conductors and deployment of 11 KV Ring Main Units (RMUs) to improve reliability, enhance safety, and ensure uninterrupted power supply.",
  location: "(Gujarat)",
  date: "--------------",
  cost: "----------------",
  authority: "MGVCL 11 KV Underground Cabling & MVCC Conductoring Project under Robust & RDSS scheme."
  },
  {
  id: "RRVPNL",
  title: "RRVPNL Grid Substation Project",
  titles: "RRVPNL Grid Substation Project",
  // titles: "RRVPNL 132 KV Grid Substation & Associated Lines Project",
  category: "ongoing",
  image: "/projects/project high quality/OP4.jpg", 
  description :"Executing turnkey EPC projects for the construction of 132 KV EHV grid substations and associated transmission lines across Bikaner, Bhilwara and Jaipur in Rajasthan. The project includes complete design, engineering, procurement, construction, testing, and commissioning to strengthen the regional power infrastructure and ensure reliable and efficient electricity transmission across these districts.",
  location: "(Bikaner, Bhilwara & Jaipur)",
  date: "--------------",
  cost: "----------------",
  authority: "RRVPNL 132 KV Grid Substation & Associated Lines Project"
  },
  {
  id: "RSDCL",
  title: "RSDCL Associated Lines Project",
  titles: "RSDCL Associated Lines Project",
  // titles: "RSDCL 220 KV Grid Substation & Associated Lines Project ",
  category: "ongoing",
 image: "/projects/project high quality/OP5.jpeg",
  description :"Construction of RE pooling station for Power Evacuation System including a 220 KV Grid Substation and associated 220 KV transmission lines for the development of a 450 MW Solar Park at Pugal, Bikaner. The project focuses on enabling efficient transmission of solar-generated power to the grid, strengthening renewable energy infrastructure and supporting large-scale clean energy integration in Rajasthan.",
  location: " (Bikaner)",
  date: "--------------",
  cost: "----------------",
  authority: "RSDCL 220 KV Grid Substation & Associated Lines Project"
  },
  {
  id: "WBSEDCL",
  title: "WBSEDCL Underground Cabling Project",
  titles: "WBSEDCL Underground Cabling Project",
  // titles: "WBSEDCL LT/11/33 KV Underground Cabling Project",
  category: "ongoing",
  image: "/projects/project high quality/OP6.jpeg",
  description :"Executing a World Bank–funded project for the conversion of existing overhead power lines into a modern underground cabling network across Siliguri, West Bengal. The project focuses on improving safety, reliability and efficiency of the power distribution system while reducing outages, minimizing environmental impact and ensuring a stable, uninterrupted electricity supply for the region’s growing urban infrastructure.",
  location: "(West Bengal)",
  date: "--------------",
  cost: "----------------",
  authority: "WBSEDCL LT/11/33 KV Underground Cabling Project"
  },
  {
  id: "GED",
  title: "GED RMU Installation Project",
  titles: "GED RMU Installation Project",
  // titles: "GED Underground Cabling & 11 KV RMU Installation Project",
  category: "ongoing",
  image: "/projects/project high quality/OP7.jpeg",
  description :"Executing the design, supply, installation, testing, and commissioning of a comprehensive underground cabling & 11 KV RMU system to upgrade the local power distribution network at Porvorim, Goa. The project focuses on strengthening electrical infrastructure by replacing conventional systems with modern underground networks, ensuring improved reliability, enhanced operational efficiency, greater safety and a more resilient power supply for the region.",
  location: "(Goa)",
  date: "--------------",
  cost: "----------------",
  authority: "GED Underground Cabling & 11 KV RMU Installation Project"
  },


























  

// completed projects
  {
  id: "JVVNL",
  title: "JVVNL Underground Cabling & Grid Substations Project",
  titles: "JVVNL Underground Cabling & Grid Substations Project",
  // titles: "JVVNL 33/11 KV Underground cabling & Grid Sub-stations Construction Project under IPDS Scheme",
  category: "completed",
  // image: "/projects/project high quality/CP1.jpg",
  image: "/projects/project high quality/CP1.png",
  description: "Executed a Central Government–funded scheme focused on strengthening the power distribution infrastructure in Jaipur, Rajasthan. The project included underground HT/LT cabling, construction of grid substations, and augmentation of power transformers to enhance capacity. It aimed at improving system reliability, minimizing outages and ensuring efficient and uninterrupted electricity supply across the region.",
  location: "",
  date: "--------------",
  cost: "----------------",
  authority: "JVVNL 33/11 KV Underground cabling & Grid Sub-stations Construction Project under IPDS Scheme"
  },
  {
  id: "JVVNL-S",
  title: "JVVNL Compact Substations Project",
  titles: "JVVNL Compact Substations Project",
  // titles: "JVVNL Compact substations & dry-type Transformer Installation Project under Smart City Scheme",
  category: "completed",
  image: "/projects/project high quality/CP2.jpeg",
  description: "Executed a Central Government–funded project in the walled city of Jaipur, Rajasthan, focused on modernizing the power distribution system. The work involved converting existing overhead lines into underground LT cables, along with the installation of dry-type transformers and compact substations, ensuring improved safety, enhanced reliability, reduced visual clutter and uninterrupted electricity supply in the heritage zone.",
  location: "(Jaipur)",
  date: "--------------",
  cost: "----------------",
  authority: "JVVNL Compact substations & dry-type Transformer Installation Project under Smart City Scheme"
  },
   {
  id: "JDA",
  title: "Underground Cabling HT/LT Project",
  titles: "Underground Cabling HT/LT Project",
  // titles: "JDA, RIICO, IRCON, PWD Underground HT/LT Cabling Projects",
  category: "completed",
  image: "/projects/project high quality/CP3.jpeg",
  description: "Executed multiple State Government projects focused on strengthening urban power distribution infrastructure. The scope included laying underground HT and LT power cables and dismantling existing overhead lines to enhance safety and system reliability. These projects aimed to modernize the electrical network, reduce outages, improve operational efficiency and ensure a cleaner and more resilient power supply system.",
  location: "",
  date: "--------------",
  cost: "----------------",
  authority: "JDA, RIICO, IRCON, PWD Underground HT/LT Cabling Projects"
  },
   {
  id: "J&A",
  title: "JVVNL & AVVNL Overhead Lines & Substations Project",
  titles: "JVVNL & AVVNL Overhead Lines & Substations Project",
  // titles: "JVVNL & AVVNL LT/11 KV Overhead lines & Sub-Stations Construction Project under DDUGJY Scheme",
  category: "completed",
  image: "/projects/project high quality/CP4.jpg",
  description: "Executed a Central Government–funded scheme in Sikar and Dausa, Rajasthan, focused on strengthening the regional power distribution network. The project included providing new household electricity connections, construction of grid substations, and feeder segregation works to improve load management, enhance reliability, and ensure efficient and uninterrupted power supply across urban and rural areas.",
  location: "(Rajasthan)",
  date: "--------------",
  cost: "----------------",
  authority: "JVVNL & AVVNL LT/11 KV Overhead lines & Sub-Stations Construction Project under DDUGJY Scheme"
  },
   {
  id: "JVVNL-LT",
  title: "JVVNL Overhead Lines & Meter Connection Project",
  titles: "JVVNL Overhead Lines & Meter Connection Project",
  // titles: "JVVNL LT Overhead lines & meter Connection Project under RGGVY Scheme",
  category: "completed",
  image: "/projects/project high quality/CP5.jpeg",
  description: "Executed a Central Government–funded scheme to provide electricity access in previously unelectrified villages across Alwar and Dausa districts in Rajasthan. The project involved the development of essential power infrastructure and installation of household connections, enabling reliable electricity supply, improving rural livelihoods, and supporting social and economic development in remote communities.",
  location: "(Rajasthan)",
  date: "--------------",
  cost: "----------------",
  authority: "JVVNL LT Overhead lines & meter Connection Project under RGGVY Scheme"
  },
   {
  id: "APDCL",
  title: "APDCL Overhead lines & meter Connection Project",
  titles: "APDCL Overhead lines & meter Connection Project",
  // titles: "APDCL LT Overhead lines & meter Connection Project under SAUBHAGYA Scheme",
  category: "completed",
  image: "/projects/project high quality/CP6.jpg",
  description: "Executed a Central Government–funded scheme to provide electricity connections to households in previously unelectrified villages in Jorhat, Assam. The project involved extending the power distribution network, installing essential electrical infrastructure, and ensuring safe and reliable electricity access. This initiative aimed to improve living standards and support social and economic development in rural communities.",
  location: "(Assam)",
  date: "--------------",
  cost: "----------------",
  authority: "APDCL LT Overhead lines & meter Connection Project under SAUBHAGYA Scheme"
  },
   {
  id: "JVVNLs",
  title: "JVVNL Underground cabling & SCADA Project",
  titles: "JVVNL Underground cabling & SCADA Project",
  // titles: "JVVNL 11 KV Underground cabling & SCADA Project under R-APDRP Scheme",
  category: "completed",
  image: "/projects/project high quality/CP7.jpg",
  description: "Executed a Central Government–sponsored scheme in Jaipur, Rajasthan, involving the development of a modern power distribution system. The project included underground HT/LT cabling, installation of 11 KV Ring Main Units (RMUs), and SCADA-compatible infrastructure works to enable advanced monitoring and control. This initiative enhanced network reliability, operational efficiency, and ensured a safer, more resilient electricity supply.",
  location: "(Rajasthan)",
  date: "--------------",
  cost: "----------------",
  authority: "JVVNL 11 KV Underground cabling & SCADA Project under R-APDRP Scheme"
  },
   {
  id: "UPCL",
  title: "UPCL Gas Insulated Substation Project",
  titles: "UPCL Gas Insulated Substation Project",
  // titles: "UPCL Gas Insulated Substation Construction Project under IPDS Scheme",
  category: "completed",
  image: "/projects/project high quality/CP8.jpg",
  description: "Executed a Central Government–funded project in Rudrapur, Uttarakhand, involving comprehensive civil and electrical works for GIS substations. The scope included installation, testing, and commissioning of advanced substation infrastructure along with incoming and outgoing 33/11 KV transmission lines. The project strengthened the regional power network and ensured reliable, efficient electricity distribution in the area.",
  location: "(Uttarakhand)",
  date: "--------------",
  cost: "----------------",
  authority: "UPCL Gas Insulated Substation Construction Project under IPDS Scheme"
  },

   {
  id: "UHBVN",
  title: "UHBVN Grid Substation Project",
  titles: "UHBVN Grid Substation Project",
  // titles: "UHBVN 33/11 KV Grid Substation Construction Project",
  category: "completed",
  image: "/projects/project high quality/CP9.jpg",
  description: "Executed a State Government project involving comprehensive civil and electrical works for the development of nine grid substations at multiple locations across Haryana. The scope included construction, installation, and commissioning of substation infrastructure along with incoming and outgoing 33/11 KV transmission lines, strengthening the regional power network and ensuring reliable, efficient electricity distribution. ",
  location: "(Haryana)",
  date: "--------------",
  cost: "----------------",
  authority: "UHBVN 33/11 KV Grid Substation Construction Project"
  },
   {
  id: "WBSEDCL-UC",
  title: "WBSEDCL Underground Cabling Project",
  titles: "WBSEDCL Underground Cabling Project",
  // titles: "WBSEDCL LT/11/33 KV Underground Cabling Project",
  category: "completed",
  image: "/projects/project high quality/CP10.jpeg",
  description: "Executed a World Bank–funded project for the conversion of existing overhead power lines into a modern underground cabling network at Rajarhat and Kharagpur, West Bengal. The project focused on strengthening the power distribution infrastructure by enhancing safety, improving operational efficiency, reducing outages, and ensuring a reliable and uninterrupted electricity supply for the region.",
  location: "(West Bengal)",
  date: "--------------",
  cost: "----------------",
  authority: "WBSEDCL LT/11/33 KV Underground Cabling Project"
  },
   {
  id: "GED-UC",
  title: "GED Underground Cabling Project",
  titles: "GED Underground Cabling Project",
  // titles: "GED 11 KV Underground Cabling Project",
  category: "completed",
  image: "/projects/project high quality/CP11.jpeg",
  description: "Executed a State Government project in Mapusa, Goa, involving the design, supply, installation, testing, and commissioning of an underground cabling system. The project focused on strengthening the local power distribution network by replacing conventional overhead infrastructure with modern underground systems, enhancing reliability, improving safety, reducing outages, and ensuring a stable and efficient electricity supply.",
  location: "(Goa)",
  date: "--------------",
  cost: "----------------",
  authority: "GED 11 KV Underground Cabling Project"
  },
   {
  id: "GED-RMU",
  title: "GED RMU Installation Project",
  titles: "GED RMU Installation Project",
  // titles: "GED 11 KV RMU Installation Project under RDSS Scheme",
  category: "completed",
  image: "/projects/project high quality/CP12.jpeg",
  description: "Successfully executed a Central Government project in Ponda, Goa, involving the design, supply, installation, testing, and commissioning of an 11 KV Ring Main Unit (RMU). The project aimed to strengthen the local power distribution network by enabling efficient load management, improving system reliability, and ensuring a safe, stable, and uninterrupted electricity supply for the region.",
  location: "(Goa)",
  date: "--------------",
  cost: "----------------",
  authority: "GED 11 KV RMU Installation Project under RDSS Scheme "
  },  
  
];

export default projectsData;
